import { NavLink } from 'react-router-dom'

// Tabs that group sibling Administración pages under one menu entry. Each tab
// is its own route, so old links and the browser's back button keep working.
export default function PestanasAdmin({ tabs }) {
  return (
    <div className="px-8 pt-6 -mb-4">
      <div className="flex gap-1 border-b border-gray-200">
        {tabs.map(tb => (
          <NavLink key={tb.to} to={tb.to}
            className={({ isActive }) => `px-4 py-2 text-sm -mb-px border-b-2 ${
              isActive ? 'border-gray-900 text-gray-900 font-medium' : 'border-transparent text-gray-500 hover:text-gray-800'}`}>
            {tb.label}
          </NavLink>
        ))}
      </div>
    </div>
  )
}
